var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.items,"outlined":"","hide-details":"","dense":""},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }